// extracted by mini-css-extract-plugin
export default {"resultsContainer":"styles_resultsContainer__Xo6Ui"};